// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"8c231835","347":"2d31f615","494":"8530e2cb","523":"efde0888","570":"5912aaee","714":"8a006614","946":"b4a1c678"}[chunkId] + ".chunk.js";
};